import { Component, OnInit,Inject } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm,FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonServiceService } from '../services/common-service.service';
import { Router,ActivatedRoute } from '@angular/router';
import {NgbModal, ModalDismissReasons,NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ErrorStateMatcher} from '@angular/material/core';
import { AuthService } from '../services/auth.service';
import { AlertService } from '../alert/alert.service';

import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  closeResult: string = '';
  forgotPasswordMailId:any;
  notFocused = false;
  errors:any;

  options = {
    autoClose: false,
    keepAfterRouteChange: false
  };

  constructor(private formBuilder: FormBuilder,
    private service: CommonServiceService,
    private router: Router,
    private _matDialog:MatDialog,
    private authService:AuthService,
    private activatedRoute:ActivatedRoute,
    public alertService: AlertService) { }

  ngOnInit(): void {
    let emailregex: RegExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailregex)]],
      password: ['',Validators.required],
      rememberMe: new FormControl(false)
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if(params.token && params.token !== ''){
        this.service.activateUser(params.token).subscribe(value => {
          this.alertService.success(value.message, this.options);
        }, error => {
          this.alertService.error(error.error.message, this.options);
        });
        this.router.navigateByUrl('/signin');
      }
  });
  }
  get f() { return this.registerForm.controls; }
  getErrorEmail() {
    return this.registerForm.get('email').hasError('required')
      ? 'Please enter registered mail ID'
      : this.registerForm.get('email').hasError('pattern')
      ? 'Not a valid emailaddress'
      : '';
  }

  getApiKey(merchant_id){
    this.service.getApiKey(merchant_id).subscribe(res=>{
      if(res.api_key) localStorage.setItem('apiKey',res.api_key)
    },error=>{
      //this.alertService.error(error.error.message, this.options);
    });
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
    const _data = {
      "email": this.registerForm.value.email,
      "password": this.registerForm.value.password
    }
    this.service.signInUser(_data,this.registerForm.value.rememberMe)
    .subscribe(
        result => {
         this.service.saveToken(result.token)
         this.service.saveBusinessRestriction(result.features_whitelisted, result.features_blacklisted);
         this.authService.saveUserInfo();
         this.service.setEmailId(this.registerForm.value.email);
         if(result.token){
           this.service.getMerchantDetail().subscribe(
             data =>{
               localStorage.setItem('merchantDetails', JSON.stringify(data));
               if(data.email_verified == 0){
                this.alertService.error('Please verify your mail id', this.options);
               } else if(data.email_verified == 1){
                  this.getApiKey(data.merchant_id);
                  this.service.setUsername(data.name);
                  this.service.getUploadedDocuments(data.merchant_id).subscribe(x => {
                    if(x.data.length > 0 || data.status == 'ACTIVE') {
                      this.router.navigateByUrl('/insights');
                    } else {
                      this.router.navigateByUrl('/info-panel');
                    }
                  });
               }
             }
           )
          }else{
            this.alertService.error(result.error.message, this.options);
         }
        },
        error => {
            this.alertService.error(error.error.message, this.options);
        }
    ); 
  }
  onReset() {
    this.submitted = false;
    this.registerForm.reset();
  }
  open() {
    this._matDialog.open(ForgotPasswordDialog);
  }
  onSendforForgotPassword(){ }
}

@Component({
  selector: 'forgotPassword-dialog',
  templateUrl: 'forgotPassword-dialog.html',
  styleUrls: ['./forgotPassword.component.css']
})
export class ForgotPasswordDialog {
  mailId: string;
  errorText: boolean = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  options = {
    autoClose: false,
    keepAfterRouteChange: false
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private service: CommonServiceService,
  private _snackbar: MatSnackBar,
  private router: Router, private _matDialog:MatDialog, public alertService: AlertService) {
    
  }
onVerify(){
  if(this.mailId == "" || this.mailId== undefined){
    this.errorText = true;
  }else{
    this.errorText= false;
    const _data = {
      "email": this.mailId
    }
    this.service.resetPasswordLink(_data)
    .subscribe(
        result => {
         if(result === 'OK'){
          this.alertService.error('Check your inbox for the email if you are already registered with us', this.options);
          this._matDialog.closeAll();
         }else{
          this.alertService.error('Failed', this.options);
         }
        },
        (error) => {
          if (error.status === 429) {
            let message = 'Too many requests. Please try again after some time.';
            if (error.error) {
              if (typeof error.error === 'string') {
                try {
                  const parsed = JSON.parse(error.error);
                  message = parsed.message || message;
                } catch (e) {}
              } else if (typeof error.error === 'object' && error.error.message) {
                message = error.error.message;
              }
            }
            this._snackbar.open(message, 'close', {
              duration: 3000,
              verticalPosition: this.verticalPosition,
              horizontalPosition: this.horizontalPosition,
            });
          } else {
            this.alertService.error('Failed', this.options);
          }
        }
    ); 
  }
  
}

}


